import {getField, updateField} from 'vuex-map-fields';


// ==================== STATE =====================

function initialState () {
  return {
    profile: null,
  };
}
const state = initialState ();


// ==================== MUTATIONS =====================

const mutations = {
  updateField,
  reset(state) {
    // acquire initial state
    const s = initialState();
    Object.keys(s).forEach(key => {
        state[key] = s[key];
    });
  },
  set_profile (state, payload) {
    state.profile = payload.profile;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
